import React, { useContext, useState } from "react";
import AllStateContext from "../context/allstateContext";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { API_RESP_STATUS } from "../Constant/constant";
import { createContactTransaction } from "../components/Apis/apis";

const AddNewContactTransactionDialog = ({ contactId, contactName, transactionType, refetch }) => {
  const [amount, setAmount] = useState("");
  const [notes, setNotes] = useState("");
  const [billDate, setBillDate] = useState(() => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // format: YYYY-MM-DD
  });
  const {
    addContactTransactionDialog,
    setAddContactTransactionDialog,
  } = useContext(AllStateContext);

  const isGave = transactionType === 1;

  const handleClose = () => {
    setAddContactTransactionDialog(false);
    setAmount("");
    setNotes("");
    setBillDate(new Date().toISOString().split("T")[0]);
  };

  const handleSave = async () => {
    const parsedAmount = parseFloat(amount);
    if (isNaN(parsedAmount) || parsedAmount <= 0) {
      alert("Please enter a valid amount greater than 0 ...!");
      return;
    }

    try {
      const body = {
        contactId: Number(contactId),
        type: Number(transactionType),
        amount: parsedAmount,
        notes: notes || "",
        billDate: billDate ? new Date(billDate) : new Date(),
      };
      
      const response = await createContactTransaction(body);
      if (
        response?.data &&
        response?.data?.status === API_RESP_STATUS.success
      ) {
        refetch();
        setAddContactTransactionDialog(false);
        setAmount("");
        setNotes("");
        setBillDate(new Date().toISOString().split("T")[0]);
      }
    } catch (error) {
      console.error("Error creating transaction:", error);
      alert(error.response?.data?.message || "Error creating transaction");
    }
  };

  return (
    <div>
      <Dialog
        fullWidth={true}
        maxWidth={"xs"}
        aria-labelledby="alert-dialog-title"
        open={addContactTransactionDialog}
        PaperProps={{
          style: {
            background: "var(--bg-secondary)",
            border: "1px solid var(--border-color)",
            borderRadius: "16px",
            color: "var(--text-primary)",
            padding: "8px",
          }
        }}
      >
        <DialogTitle 
          style={{ 
            fontWeight: "700", 
            fontSize: "1.25rem",
            color: isGave ? "var(--danger, #ff4d4d)" : "var(--success, #00e676)"
          }}
        >
          {isGave ? `Gave to ${contactName}` : `Got from ${contactName}`}
        </DialogTitle>
        
        <DialogContent>
          <div
            className="form-floating"
            style={{ marginTop: "15px", marginBottom: "15px" }}
          >
            <input
              name="amount"
              type="number"
              min="0.01"
              step="any"
              required
              onChange={(e) => setAmount(e.target.value)}
              value={amount}
              className="form-control amount-input"
              placeholder=" "
              id="txAmount"
              style={{
                fontSize: "1.5rem",
                fontWeight: "700",
                height: "60px",
                color: isGave ? "var(--danger, #ff4d4d)" : "var(--success, #00e676)"
              }}
            />
            <label htmlFor="txAmount" style={{ fontSize: "0.9rem" }}>Amount (₹)</label>
          </div>

          <div
            className="form-floating"
            style={{ marginTop: "15px", marginBottom: "10px" }}
          >
            <textarea
              name="notes"
              onChange={(e) => setNotes(e.target.value)}
              value={notes}
              className="form-control"
              placeholder=" "
              id="txNotes"
              style={{ height: "100px", resize: "none" }}
            />
            <label htmlFor="txNotes">Add Note / Description</label>
          </div>
          <div
            style={{ marginTop: "15px", marginBottom: "10px" }}
          >
            <label 
              htmlFor="txDate"
              style={{ 
                display: "block",
                fontSize: "0.82rem",
                fontWeight: "600",
                color: "rgba(255,255,255,0.5)",
                marginBottom: "6px",
                letterSpacing: "0.03em"
              }}
            >
              📅 Date
            </label>
            <input
              name="billDate"
              type="date"
              id="txDate"
              value={billDate}
              onChange={(e) => setBillDate(e.target.value)}
              className="form-control"
              style={{
                fontSize: "0.95rem",
                fontWeight: "600",
                height: "46px",
                color: "var(--text-primary)",
                borderColor: isGave
                  ? "rgba(239, 83, 80, 0.4)"
                  : "rgba(102, 187, 106, 0.4)",
                colorScheme: "dark",
              }}
            />
          </div>
        </DialogContent>

        <DialogActions style={{ padding: "12px 24px" }}>
          <button 
            className="btn btn-secondary" 
            onClick={handleClose}
            style={{ 
              borderRadius: "8px", 
              padding: "8px 20px",
              fontWeight: "600" 
            }}
          >
            Cancel
          </button>
          <button 
            className={`btn ${isGave ? 'btn-danger' : 'btn-success'}`}
            onClick={handleSave}
            style={{ 
              borderRadius: "8px", 
              padding: "8px 24px",
              fontWeight: "600",
              backgroundColor: isGave ? "var(--danger, #ff4d4d)" : "var(--success, #00e676)",
              borderColor: isGave ? "var(--danger, #ff4d4d)" : "var(--success, #00e676)",
              color: "#fff"
            }}
          >
            Save Entry
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default AddNewContactTransactionDialog;
